const TriStateToggle = ({ value, onChange }) => {
  const label =
    value === "image" ? "📷 Kép"
      : value === "video" ? "🎬 Videó"
        : "📁 Mind";

  const cycle = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (value === "image") onChange("video");
    else if (value === "video") onChange("all");
    else onChange("image");
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      }}
    >
      {/* Bal oldali gomb – fix szélesség */}
      <button
        style={{
          padding: "2px 8px",
          borderRadius: 4,
          border: "1px solid #ccc",
          background: "white",
          cursor: "pointer",
          width: 90,              // <<< FIXÁLT SZÉLESSÉG
          textAlign: "left"       // vagy "center", ha középre szeretnéd
        }}
        onClick={cycle}
      >
        {label}
      </button>

      {/* Középen a Filter felirat */}
      <div
        style={{
          flex: 1,
          textAlign: "center",
          fontWeight: 500,
          pointerEvents: "none"
        }}
      >
        Filter
      </div>

      {/* Jobb oldali "dummy" hely biztosítja a valódi középre igazítást */}
      <div style={{ width: 90 }}></div>
    </div>
  );
};

export default TriStateToggle;
